import { render } from "./CollectionPage.vue?vue&type=template&id=80abdbf4&lang=pug"
import script from "./CollectionPage.vue?vue&type=script&lang=ts"
export * from "./CollectionPage.vue?vue&type=script&lang=ts"
script.render = render

export default script